"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var function_double_1 = require("function-double");
var classUtils_1 = require("./classUtils");
var isReactClass = function (component) { return react_1.Component.isPrototypeOf(component); };
function rename(target, newName) {
    if (typeof target !== 'function') {
        return target;
    }
    var dupe = (isReactClass(target)
        ? classUtils_1.classDuplicator(target)
        : function_double_1.default(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return target.apply(void 0, args);
        }, target));
    classUtils_1.safeDefine(dupe, 'name', {
        configurable: true,
        writable: false,
        enumerable: false,
        value: newName
    });
    classUtils_1.safeDefine(dupe, 'displayName', {
        configurable: true,
        writable: false,
        enumerable: false,
        value: newName
    });
    return dupe;
}
exports.rename = rename;
